// extracted by mini-css-extract-plugin
export default {"main":"main-main-I4VuEY"};